import API from '../../../../../services/api';

export const API_COMERCIALES = {
    getDetallesEntidades: async (page = 1, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/detalle-comercial' + pagination + searcher).then(res => res.data);
    },
    newEntidadComercial: async (entidad) => {
        return API.post('/detalle-comercial/', entidad).then(res => res.data);
    },
    newDetalleComercial: async (detalle) => {
        return API.post('/detalle-comercial/'+ detalle.entity_id +'/nuevo', detalle).then(res => res.data);
    },
    newProximoContacto: async (contacto) => {
        return API.post('/detalle-comercial/'+ contacto.entity_id +'/proximo-contacto/', contacto).then(res => res.data);
    },
    updateObservaciones: async (observaciones) => {
        return API.post('/detalle-comercial/'+ observaciones.entity_id +'/observaciones', observaciones).then(res => res.data);
    },
    updateDetalleComercial: async (detalle) => {
        return API.put('/detalle-comercial/'+ detalle.id, detalle).then(res => res.data);
    },
    /****** CONTACTOS ******/
    newContacto: async (entityId, contacto) => {
        return API.post('/detalle-comercial/' + entityId + '/contacto', contacto).then(res => res.data);
    },
    updateContacto: async (contacto) => {
        return API.put('/detalle-comercial/'+ contacto.id +'/update-contacto', contacto).then(res => res.data);
    },
    /****** IMPORTS & EXPORTS ******/
    exportConversionEntidadesExcel: async (filters) => {
        return API.post('/detalle-comercial/export/conversion', filters, {responseType: 'blob'}).then(res => res.data);
    },
    comprobarTelefonos: async (data) => {
        return API.post('/detalle-comercial/export/comprobar', data, {responseType: 'blob'}).then(res => res.data);
    }
}